// extracted by mini-css-extract-plugin
module.exports = {"card":"BasicCard_card__JxRNQ","enrollment":"BasicCard_enrollment__zoJgh","title":"BasicCard_title__iGdtq","cardContent":"BasicCard_cardContent__zJhwA"};